import { FC } from "react";
import { StyledFooter, FooterElement } from "./styled";
import Typography from "@mui/material/Typography";
import mockEmployees from "../../mockEmloyees.json";

const Footer: FC<{ count: number }> = ({ count }) => (
  <StyledFooter>
    <FooterElement>
      Организация:{" "}
      <Typography color="black" fontSize="12px" marginLeft="8px">
        Skinserve
      </Typography>
    </FooterElement>
    <FooterElement>
      Общее количество:{" "}
      <Typography color="black" fontSize="12px" marginLeft="8px">
        {count}
      </Typography>
    </FooterElement>
  </StyledFooter>
);

export default Footer;
